import { MicroLabel } from '@/ui/micro-label';
import { Button } from '@/ui/button';

/**
 * The foot of a paged list.
 *
 * Always says how many rows are on screen, whether or not more exist — the count is the part that
 * was missing. A table showing 30 of 39 with nothing to say so is indistinguishable from a table
 * showing all of them, and the operator has no reason to suspect the difference.
 */
export function LoadMore({
  shown,
  total,
  hasMore,
  loading,
  onLoadMore
}: {
  shown: number;
  /** From the listing's own totals when it has them; omitted when nothing states it. */
  total?: number | null;
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}) {
  if (!shown) return null;
  return (
    <div className="mt-3 flex items-center justify-between gap-4">
      <MicroLabel size="xs" tone="muted">
        {total && total > shown ? `${shown} of ${total} shown` : `${shown} shown`}
      </MicroLabel>
      {hasMore ? (
        <Button size="sm" variant="secondary" disabled={loading} onClick={onLoadMore}>
          {loading ? 'Loading…' : 'Load more'}
        </Button>
      ) : null}
    </div>
  );
}
